import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import CourseExclusionSettingsModal from "../Content/Courses/CourseDetails/CourseExclusionSettingsModal";

const RemoveAssignmentButton = ({
  onClick,
  rowData,
  label,
  call,
  open,
  setOpen,
  disabled
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Button color="primary" onClick={onClick} disabled={disabled}>
        {t(`userAssignments.${label}`)}
      </Button>
      {
        <CourseExclusionSettingsModal
          onClose={() => setOpen(false)}
          open={open}
          onSubmit={exclusionData => {
            call(exclusionData);
            setOpen(false);
          }}
          title={rowData.trainingObject.name}
          initialValues={
            rowData.exclusion
              ? {
                  comment: rowData.exclusion.data.attributes.note,
                  expiresAt: rowData.exclusion.data.attributes.expiresAt
                }
              : false
          }
        />
      }
    </>
  );
};

export default RemoveAssignmentButton;
